import { useEffect, useState } from 'react';
import { getItemOptions } from '../../api/options';
import { SearchAsYouType } from '../shared/search-as-you-type';

export const ItemSearchInput = ({
  defaultItemId = '',
  disabled = false,
  onItemSelected = () => {},
  label = 'Select Item',
  error = false,
}) => {
  const [itemId, setItemId] = useState('');

  useEffect(() => {
    const selectItem = async (itemId) => {
      const items = await getItemOptions({
        itemId,
      });
      const item = items?.find((i) => i.item_id === itemId);
      if (item) {
        onItemSelected(item);
      }
    };

    if (!itemId && defaultItemId) {
      setItemId(defaultItemId);
      selectItem(defaultItemId);
    }
  }, [defaultItemId]);

  return (
    <SearchAsYouType
      label={label}
      value={itemId}
      disabled={disabled}
      error={error}
      variant='outlined'
      onChange={(e, selectedItem) => {
        if (selectedItem) {
          setItemId(selectedItem.item_id);
          onItemSelected(selectedItem || {});
        }
      }}
      onBlur={(e, selectedItem) => {
        // Quick item entry without mouse clicks
        if (selectedItem) {
          setItemId(selectedItem.item_id);
          onItemSelected(selectedItem);
        }
      }}
      getSearchOptions={(searchString) =>
        getItemOptions({
          searchString,
        })
      }
    />
  );
};
